import * as React from 'react';

/** True while rendering the content inside a radio item label. */
export const RadioItemLabelContext = React.createContext(false);
